import Cookies from "js-cookie";
import { TokenRefreshRequest } from "../types/tokenRefreshRequest";

const cookieNames = {
    token: "apl_user_token",
    refreshToken: "apl_refresh_token",
    refreshing: "apl_refreshing_token",
    persist: "apl_persist_token"
};


const getTokensInternal = (): TokenRefreshRequest => {
    let token = Cookies.get(cookieNames.token) ?? "";
    // let refreshToken = Cookies.get(cookieNames.refreshToken) ?? "";
    let refreshToken = localStorage.getItem(cookieNames.refreshToken) ?? Cookies.get(cookieNames.refreshToken) ?? "";
    // let refreshing = Cookies.get(cookieNames.refreshing);
    let refreshing = localStorage.getItem(cookieNames.refreshing) ?? Cookies.get(cookieNames.refreshing) ?? "";
    // let persist = Cookies.get(cookieNames.persist);
    let persist = localStorage.getItem(cookieNames.persist) ?? Cookies.get(cookieNames.persist) ?? "";

    if (!token || !refreshToken) {
        return {
            token: "",
            refreshToken: "",
            refreshing: false,
            persist: false
        };
    } else {
        return {
            token: token,
            refreshToken: refreshToken,
            refreshing: refreshing === "true",
            persist: persist === "true"
        };
    }
};

const setTokensInternal = (tokens: TokenRefreshRequest) => {
    if (tokens.persist) {
        Cookies.set(cookieNames.token, tokens.token, { expires: 365 });
        Cookies.set(cookieNames.refreshToken, tokens.refreshToken, { expires: 365 });
        localStorage.setItem(cookieNames.refreshToken, tokens.refreshToken);
        // Cookies.set(cookieNames.refreshing, tokens.refreshing.toString(), { expires: 365 });
        localStorage.setItem(cookieNames.refreshing, tokens.refreshing.toString());
        // Cookies.set(cookieNames.persist, tokens.persist.toString(), { expires: 365 });
        localStorage.setItem(cookieNames.persist, tokens.persist.toString());
    } else {
        Cookies.set(cookieNames.token, tokens.token);
        // Cookies.set(cookieNames.refreshToken, tokens.refreshToken);
        localStorage.setItem(cookieNames.refreshToken, tokens.refreshToken);
        // Cookies.set(cookieNames.refreshing, tokens.refreshing.toString());
        localStorage.setItem(cookieNames.refreshing, tokens.refreshing.toString());
        // Cookies.set(cookieNames.persist, tokens.persist.toString());
        localStorage.setItem(cookieNames.persist, tokens.persist.toString());
    }
};

const setAplTokens = (tokens: TokenRefreshRequest) => {
    setTokensInternal(tokens);
};

const setAplTokensRefreshing = () => {
    let tokens = getTokensInternal();
    if (tokens.token) {
        tokens.refreshing = true;
        setTokensInternal(tokens);
    } else {
        console.log(`${new Date().toISOString()} - setAplTokensRefreshing: no tokens found in cookie`);
        return;
    }
};

const updateAplTokens = (token: string, refreshToken: string) => {
    let tokens = getTokensInternal();
    tokens.token = token;
    tokens.refreshToken = refreshToken;
    tokens.refreshing = false;
    setTokensInternal(tokens);
};

const removeAplTokens = () => {
    let tokens = getTokensInternal();
    console.log(`${new Date().toISOString()} - removeAplTokens`, tokens);
   
    for (const cookie in Cookies.get()) Cookies.remove(cookie);
    localStorage.clear();

} 

const getAplTokens = (): TokenRefreshRequest => {
   return getTokensInternal();
};

export { setAplTokens, setAplTokensRefreshing, updateAplTokens, removeAplTokens, getAplTokens };
